import React, { useCallback, useEffect, useState } from 'react';
import {
    Alert,
    Box,
    Button,
    Chip,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import httpClient, { extractErrorMessage } from '../Services/httpClient';

const LeadsPanel = () => {
    const [items, setItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [notifyingId, setNotifyingId] = useState(null);

    const load = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await httpClient.get('/backoffice/email-leads');
            setItems(response.data);
        } catch (err) {
            setError(extractErrorMessage(err));
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    const handleMarkNotificado = async (id) => {
        setNotifyingId(id);
        setError(null);
        try {
            await httpClient.put(`/backoffice/email-leads/${id}/notificado-trilha-b`);
            setItems((prev) => prev.map((item) => (item.id === id ? { ...item, notificado: true } : item)));
        } catch (err) {
            setError(extractErrorMessage(err));
        } finally {
            setNotifyingId(null);
        }
    };

    return (
        <Box>
            <Typography variant="subtitle1" sx={{ color: '#f77513', fontWeight: 'bold', mb: 1 }}>
                Leads — Teste Vocacional
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Todo mundo que informou e-mail ao fazer o teste vocacional (Trilha A ou B, com ou sem teste concluído) — captura de lead sempre opcional, feita no início do teste. "Notificado" só se aplica a quem estava na fila de espera histórica da Trilha B, antes dela existir de verdade.
            </Typography>

            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            {isLoading ? (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                    <CircularProgress size={28} style={{ color: '#f77513' }} />
                </Box>
            ) : (
                <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: '14px' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow style={{ backgroundColor: '#fff4ec' }}>
                                <TableCell>E-mail</TableCell>
                                <TableCell>Faixa etária</TableCell>
                                <TableCell>Anos de experiência</TableCell>
                                <TableCell>Cadastrado em</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell align="right">Ação</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={6} align="center" style={{ color: '#aaa', padding: '24px' }}>
                                        Nenhum lead capturado ainda
                                    </TableCell>
                                </TableRow>
                            )}
                            {items.map((item) => (
                                <TableRow key={item.id}>
                                    <TableCell>{item.email}</TableCell>
                                    <TableCell>{item.faixaEtaria}</TableCell>
                                    <TableCell>{item.anosExperiencia}</TableCell>
                                    <TableCell style={{ whiteSpace: 'nowrap' }}>{item.createdAt}</TableCell>
                                    <TableCell>
                                        {item.notificado
                                            ? <Chip label="Notificado" size="small" style={{ backgroundColor: '#e8f5e9', color: '#2e7d32' }} />
                                            : <Chip label="Pendente" size="small" style={{ backgroundColor: '#fdecea', color: '#c62828' }} />}
                                    </TableCell>
                                    <TableCell align="right">
                                        {!item.notificado && (
                                            <Button
                                                size="small"
                                                startIcon={<MarkEmailReadIcon />}
                                                disabled={notifyingId === item.id}
                                                onClick={() => handleMarkNotificado(item.id)}
                                                sx={{ color: '#f77513' }}
                                            >
                                                Marcar como notificado
                                            </Button>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
};

export default LeadsPanel;
